import React, { Fragment, useEffect } from 'react';

export default () => {
  useEffect(() => {
    document.title = '陕西奕诚生物科技有限公司 - 公司概况';
  });
  return (
    <Fragment>
      <div className="summary row">
        <div className="slogan" id="slogan">
        </div>
        <div className="content" id="summary">
          <p>公司目前拥有核桃基地3500亩，板栗基地3000亩，树莓、蓝莓、灯笼果、紫锥菊、美洲黄芪等1100亩。</p>
          <p>阳光温室900平方，温室大棚500平方，阳光大棚占地30亩（55个）。</p>
          <p>研发中心位于国家技术研发中心，面积3000多平方，设备齐全仅2014年一次性补充设备就投资了1100万。生产工厂位于秦岭山区镇安县云镇，优质的空气质量加上绿色有机的原材料，用科学的生产工艺生产出来的产品不仅口感香醇更利于健康。工厂1800平方。</p>
          <p>展示区从台湾引进的蔬菜有紫背天葵、降压菜、救心菜、迷迭香、台湾薄荷等27种蔬菜。公司着重研发功能性食品，把秦岭山区绿色有机的山特产品融入高科技技术。使产品不但绿色有机并有一定的治疗功能，真正的做到药食同源。公司目前员工37人，本科以上学历的占公司一半以上。</p>
        </div>
      </div>
      <div className="cross-row">
        <div className="row" id="cooperators">
          <div className="title">
            <span>公司组成</span>
          </div>
          <div className="image"></div>
          <div className="cooperator">
            <p>2007年注册，注册资金330万元</p>
            <p>林权7000余亩，快繁基地8个大棚</p>
            <p>展示大厅一个，种植大棚35个</p>
            <p>种植示范基地4个</p>
            <p>快繁基地、七叶树基地</p>
            <p>经济药用植物基地</p>
          </div>
          <div className="cooperator">
            <p>2014年4月注册，注册资金300万元</p>
            <p>生产加工厂房2000平米</p>
            <p>研发中心一个，战略合作单位4个</p>
            <p>药用植物的粗加工</p>
            <p>经济作物的加工</p>
            <p>珍惜植物的生物提取</p>
          </div>
          <div className="cooperator">
            <p>2009年3月注册，注册资金300万元</p>
            <p>社员139人</p>
            <p>面积2000余亩</p>
            <p>核桃生产加工基地</p>
          </div>
        </div>
      </div>
      <div id="cooperative">
        <div className="icon icon-info-cooperatives"></div>
        <div className="content">
          <div className="title">
            <span>战略合作单位</span>
          </div>
          <p>
            <span className="name">西安岳达植物科技有限公司：</span>
            <span className="feature">新产品的开发、销售</span>
          </p>
          <p>
            <span className="name">西北农林科技大学：</span>
            <span className="feature">植物的快繁及种植</span>
          </p>
          <p>
            <span className="name">西安交通大学：</span>
            <span className="feature">企业管理、销售</span>
          </p>
          <p>
            <span className="name">清华大学生物系：</span>
            <span className="feature">新产品的检测分析</span>
          </p>
        </div>
      </div>
      <div className="cross-row">
        <div id="patent">
          <div className="title row">
            <div className="icon icon-info-patent"></div>
            <span className="name">专利和特色产品</span>
          </div>
          <div className="content row">
            <div className="patent" id="patent-1">
              <div className="illustration"></div>
              <div className="description">
                一种从红树莓叶子中提取黄酮类物质的高效环保方法
          </div>
            </div>
            <div className="patent" id="patent-2">
              <div className="illustration"></div>
              <div className="description">
                一种美国红树莓苗的无激素培养及快速繁殖方法
          </div>
            </div>
            <div className="patent" id="patent-3">
              <div className="illustration"></div>
              <div className="description">
                一种富硒富锗果蔬喷洒液及其制备方法
          </div>
            </div>
            <div className="patent" id="patent-4">
              <div className="illustration"></div>
              <div className="description">
                一种快速繁殖铁皮石斛苗的方法
          </div>
            </div>
          </div>
        </div>
      </div>
      <div id="research-status">
        <div className="title">
          <div className="icon icon-info-research"></div>
          <span className="name">研究中心</span>
        </div>
        <div className="content">
          <p>
            建立了分析实验室，购置了高效液相色谱仪、紫外-可见分光度计、水分分析仪、蛋白质测定仪、熔点仪、旋光仪、霉菌培养箱、显微镜等检测设备，确保产品的各项指标均能达到标准要求。
      </p>
        </div>
        <div className="researchers" id="researchers">
          <div className="researcher" id="researcher-1">
            <span>
              <span className="name">胡歩超</span>
              <span className="intro">，61岁，本科学历，</span>
              <span className="desc">曾在华南植物研究所任职，现公司基地技术负责人。</span>
            </span>
          </div>
          <div className="researcher" id="researcher-2">
            <span>
              <span className="name">张志勤</span>
              <span className="intro">，40岁，硕士学历，</span>
              <span className="desc">主要研究中药材的品种选育及规范化栽培技术研究和植物生物技术研究。</span>
            </span>
          </div>
          <div className="researcher" id="researcher-3">
            <span>
              <span className="name">李璞</span>
              <span className="intro">，47岁，西安医科大学硕士毕业，</span>
              <span className="desc">主要负责生物产品的研发工作。</span>
            </span>
          </div>
          <div className="researcher" id="researcher-4">
            <span>
              <span className="name">董全喜</span>
              <span className="intro">，55岁，农艺师，</span>
              <span className="desc">主要负责苗木种植栽培。</span>
            </span>
          </div>
          <div className="researcher" id="researcher-5">
            <span>
              <span className="name">张天</span>
              <span className="intro">，34岁，防化研究院生物专业博士毕业，</span>
              <span className="desc">主要负责植物生物提取工作。公司技术研发总监。</span>
            </span>
          </div>
          <div className="researcher" id="researcher-6">
            <span>
              <span className="name">吴新明</span>
              <span className="intro">，34岁，西北工业大学材料学专业博士毕业，</span>
              <span className="desc">主要负责公司的新产品的提取和开发工作。公司技术研发副总监。</span>
            </span>
          </div>
          <div className="researcher" id="researcher-7">
            <span>
              <span className="name">戈军</span>
              <span className="intro">，32岁，清华大学生物系副教授，博士，</span>
              <span className="desc">公司项目研发顾问。</span>
            </span>
          </div>
        </div>
      </div>
  
    </Fragment>
  );
}
